const sortTypeUtil = (sortName) => {
  //return sort type that will be use in sortHelper
  if (sortName === "name" || sortName === "title") {
    return "string"
  } else if (sortName === "duration") {
    return "duration"
  } else if (
    sortName === "lessons" ||
    sortName === "learning paths" ||
    sortName === "labs" ||
    sortName === "type" ||
    sortName === "used"
  ) {
    return "number"
  } else if (sortName === "codes" || sortName === "courses") {
    return "length"
  } else {
    return "date"
  }
}

export default sortTypeUtil
